<template>
<div>
<div class="cancellation_subscription" v-if=" currentCountryCode === 'US' && subscriptionDetails.isBCBSSubscription === true || currentCountryCode === 'NL' && subscriptionDetails.title.includes ('ONVZ')">
      <h3 class="text">
        {{ $t('subscription_details.bundles.cancellation.text', 'Cancel the subscription') }}
      </h3>

      <p class="tips">
        {{ $t('subscription_details.bundles.cancellation.content', 'Sorry to see you go already... ... by clicking the button below') }}
      </p>

      <app-button
        type="submit"
        class="cancelProcess"
        @click.prevent="openModalStep2"
      >
        {{ $t('subscription_details.bundles.cancellation.button.process', "Process") }}
      </app-button>
      <div class="cancellation_subscription_reasons">
        <app-modal name="step2" @after-closed="emptyCancelData">
          <div class="v--modal-content">
            <h3 class="modal-title">
            </h3>
            <div class="modal-content">
              <div class="CancleSubscription_ReasonForm">
                <h4>
                  {{ $t('subscription_details.accordion.cancel.form.reason', 'Reason for cancelling') }}
                </h4>

                <div class="CheckboxGroup">
                  <app-checkbox
                    v-for="(item, index) in cancelReason"
                    :key="index"
                    :id="'reason' + (index + 1)"
                    :label="item.text"
                    :value="item.checked"
                    @input="item.checked = $event"
                  />
                </div>

                <app-textarea
                  :placeholder="$t('subscription_details.accordion.cancel.form.textarea', 'Please tell us more')"
                  v-model.trim="cancelMoreInfo"
                  maxlength="200"
                />

                <div class="modal-button-warpper">
                  <app-button
                    @click="closeModalStep2"
                    :disabled="!cancelReasonSelected && !cancelMoreInfo"
                    class="cancel_closeModal"
                  >
                    {{ $t('subscription_details.accordion.cancel.onlyReplenishment.button.cancel', 'Cancel') }}
                  </app-button>

                  <app-button
                    @click.prevent="cancellationSubscriptionTask.run()"
                    :disabled="!cancelReasonSelected && !cancelMoreInfo"
                    :is-loading="cancellationSubscriptionTask.isActive"
                    class="cancel_openModal"
                  >
                    {{ $t('subscription_details.accordion.cancel.onlyReplenishment.button.proceed', 'Proceed') }}
                  </app-button>
                </div>
              </div>
            </div>
          </div>
        </app-modal>
      </div>
      <app-modal name="newFlowForCancelReplenishment1"  width="500px">
        <div class="v--modal-content">
          <h3 class="modal-title">
          </h3>
          <div class="modal-content">
            <div class="newFlowForCancelReplenishment1_popUp">
              <h4>
                {{ $t('subscription_details.cancellation.popUp.tips', "We are sorry to hear that you want to cancel your subscription.") }}
              </h4>
              
               <div class="modal-button-warpper" v-if=" currentCountryCode === 'US' && subscriptionDetails.isBCBSSubscription === true || currentCountryCode === 'NL' && subscriptionDetails.title.includes ('ONVZ')">
                   <app-button
                  class="cancel_openModal"
                  @click.prevent="cancelSubscription"
                >
                  {{ $t('subscription_details.cancellation.popUp.button.cancel', "Cancel") }}
                </app-button>
               </div>
            </div>
          </div>
        </div>
      </app-modal>
  </div>

  <div class="NotOnlyReplenshipment" v-if="subscriptionDetails.isBCBSSubscription === false && !(currentCountryCode === 'NL' && subscriptionDetails.title.includes ('ONVZ'))">
    <div>
      <p class="text" v-if="subscriptionDetails.shippingConfirmed === true">
        {{ $t('subscription_return.cancelOrReturn.popUp.content.text', 'Select which part of the starter kit you would like to cancel') }}
      </p>
      <p class="tips" v-if="subscriptionDetails.shippingConfirmed === false">
            {{ $t('subscription_return.cancelOrReturn.popUp.content.text1', 'Your order is almost ready to ship and cannot be canceled through your online account at this time. Please contact our customer service who are happy to help. Contact details available at the Support section') }}
          </p>

      <!-- cancel and return subscription accordion content -->
      <div class="trybuy_cancel_options" v-if="subscriptionDetails.shippingConfirmed === true">
        <div class="cancelButNotReturn">
          <app-checkbox
            v-for="(item, index) in canDoReturnBundles"
            :key="index"
            :id="item.id"
            :label="item.text"
            @input="item.checked = $event"
            :value="item.checked"
          />
        </div>
      </div>

      <p
        class="trybuyReturnAndReplCancel_tips"
        v-if="this.subscriptionDetails.ableToCancelReplenishment && !replenshipmentReturnInfos.returnable && deviceReturnInfos.returnable">
        {{ $t('subscription_return.bundles.accordion.tips.content', {
          device: device.name,
          replenishment: replenshipment.name
        }) }}
      </p>

      <app-button
        v-if="subscriptionDetails.shippingConfirmed === true"
        type="submit"
        class="cancelProcess"
        :disabled="!returnOptionType"
        @click.prevent="returnProcessStart"
      >
        {{ $t('subscription_return.cancelOrReturn.popUp.button.processed', 'Proceed') }}
      </app-button>
      <!-- open return or cancel options -->
      <app-modal name="selectReturnOrCancel" @after-closed="emptyCancelData" class="selectReturnOrCancel">
        <div class="v--modal-content">
          <h3 class="modal-title">
          </h3>
          <div class="modal-content">
            <div class="CancleSubscription_ReasonForm">
              <p class="title">
                <span>{{ $t('subscription_return.bundles.cancelOptions.cancelReason.title', 'Would you like to keep the') }} </span>
                <span v-for="(item, index) in allowNextStep" :key="index">{{ item.text }} </span>
                <span>{{ $t('subscription_return.bundles.cancelOptions.cancelReason.subTitle', 'already received?') }}</span>
              </p>
              <p class="subTips">
                {{ $t('subscription_return.bundles.cancelOptions.cancelReason.tips', 'Please note that we only accept returns that are unused and in the original packaging.') }}
              </p>

              <div class="selectRadio">
                <ul>
                  <li
                    v-for="(item, index) in cancelOrReturnOption"
                    :key="index"
                    class="cancelButNotReturn"
                    :class="{'disabled': (item.id === 'cancel-type-keep' && disabledCancelButton)}"
                    @click="selectCancelOrReturnOption(index, item)">
                    <span
                      class="payment-method_radio"
                      :id="item.id"
                      :class="{'payment-method_radioExtend' : currentIndex === index && ((item.id !== 'cancel-type-keep' && returnOptionType !== 'Replenishment') || returnOptionType === 'Replenishment')}"
                      ref="returnSubscription"></span>
                    <span>{{ item.text }}</span>
                  </li>
                </ul>
              </div>

              <p class="tips">
                <span>{{ $t('subscription_return.bundles.rightToReturnDays.description.text', { rightToReturnDays: rightToReturnDays}) }}</span>
              </p>

              <div class="modal-button-warpper">
                <app-button
                  :disabled="!step1Show"
                  class="cancel_closeModal"
                  @click="cancelReturn"
                >
                  {{ $t('subscription_details.accordion.cancel.onlyReplenishment.button.cancel', 'Cancel') }}
                </app-button>

                <app-button
                  type="submit"
                  :disabled="!step1Show"
                  @click="selectReturnOptions"
                  class="cancel_openModal"
                >
                  {{ $t('subscription_details.accordion.cancel.onlyReplenishment.button.proceed', 'Proceed') }}
                </app-button>
              </div>
            </div>
          </div>
        </div>
      </app-modal>

      <!-- return reason pop up --- submitReturnSubscriptionReason-->
      <app-modal name="submitReturnSubscriptionReason" @after-closed="emptyCancelData">
        <div class="v--modal-content">
          <h3 class="modal-title">
          </h3>
          <div class="modal-content">
            <div class="CancleSubscription_ReasonForm">
              <h4>
                {{ $t('subscription_details.accordion.cancel.form.reason', 'Reason for cancelling') }}
              </h4>

              <div class="CheckboxGroup">
                <app-checkbox
                  v-for="(item, index) in cancelReason"
                  :key="index"
                  :id="'reason' + (index + 1)"
                  :label="item.text"
                  :value="item.checked"
                  @input="item.checked = $event"
                />
              </div>

              <app-textarea
                :placeholder="$t('subscription_details.cancelOrReturn.popUp.cancel.form.textarea', 'Please tell us more')"
                v-model.trim="cancelMoreInfo"
                maxlength="200"
              />

              <div class="modal-button-warpper">
                <app-button
                  @click="CancelreturnSubscriptionReasonPopup"
                  :disabled="!cancelReasonSelected && !cancelMoreInfo"
                  class="cancel_closeModal"
                >
                  {{ $t('subscription_details.cancelOrReturn.popUp.cancel.button.cancel', 'Cancel') }}
                </app-button>

                <app-button
                  @click.prevent="submitReturnSubscriptionReason.run()"
                  :disabled="!cancelReasonSelected && !cancelMoreInfo"
                  :is-loading="submitReturnSubscriptionReason.isActive"
                  class="cancel_openModal"
                >
                  {{ $t('subscription_details.cancelOrReturn.popUp.cancel.button.proceed', 'Proceed') }}
                </app-button>
              </div>
            </div>
          </div>
        </div>
      </app-modal>
      <!--checkReturnAddress  -->
      <app-modal name="checkReturnAddress" @after-closed="emptyCancelData">
        <div class="v--modal-content">
          <h3 class="modal-title">
          </h3>
          <div class="modal-content">
            <div class="CancleSubscription_ReasonForm">
              <p class="title">
                {{ $t('subscription_return.cancelOrReturn.popUp.confirmAddress.title', 'Confirm your current address') }}
              </p>

              <p class="tips">
                {{ $t('subscription_return.cancelOrReturn.popUp.confirmAddress.tips', 'We will send you a pre-addressed return label for you to easily return the product. Please check if your contact details are up to date.') }}
              </p>

               <div
                    class="SelectGroup Form_group return_address"
                    v-if="currentCountryCode === 'GB'"
                    :class="{'error': errorsFor('county').length > 0}">
                   
                    <app-select
                      :placeholder="showSelectLabel ? null : $t('subscription_return.cancelOrReturn.popUp.device.confirmAddress.tips2', 'Select your Region*' )"
                      v-model="stateCode"
                      :options="region"
                      :searchable="true"
                      :allow-empty="false"
                      :show-labels="false"
                      open-direction="bottom"
                      :disabled="submitUpdateReturnAddress.isActive"
                      :internal-search="false"
                      @search-change="searchCounty"
                      @open="showLabel"
                      @close="validenableDisplayLabel"
                      :class="{'extend': showSelectLabel}"
                    >
                      <span slot="noResult">{{ $t('common.select.search.noResult', 'Not result') }}</span>
                    </app-select>

                    <p class="tip-error" v-for="(error, index) in errorsFor('county')" :key="index">
                      {{ $t('common.address.textLabel&placeholder.county', 'County*') }} {{ error }}
                    </p>
                  </div>

              <p class="update_address_success" v-if="updateAddressSuccess">
                {{ $t('subscription_return.cancelOrReturn.popUp.confirmAddress.updateAddress.success.tip', 'Address successfully updated') }}
              </p>

              <div class="address">
                <div>
                  <app-edit-button
                    class="address_edit"
                    data-name="verifyAddress-editButton"
                    :disabled="!stateCode && currentCountryCode === 'GB'"
                    @click.prevent="editAddress"
                  />
                </div>
                <div class="address_content">
                  <template v-if="currentCountryCode === 'GB'">
                    <p>{{ line1 }}</p>
                    <p>{{ line2 }}</p>
                    <p>{{ zipCode }}</p>
                    <p>{{ city }}</p>
                    <p>{{ selectedCountryState && selectedCountryState.name }}</p>
                  </template>
                  <template v-if="currentCountryCode === 'ES'">
                    <p>{{ line1 }}</p>
                    <p>{{ line2 }}</p>
                    <p>{{ zipCode }}</p>
                    <p>{{ city }}</p>
                    <p>{{ selectedCountryState && selectedCountryState.name }}</p>
                  </template>
                  <template v-if="currentCountryCode === 'BE'">
                    <p>{{ line1 }}</p>
                    <p>{{ line2 }}</p>
                    <p>{{ zipCode }}</p>
                    <p>{{ city }}</p>
                    <p>{{ county }}</p>
                  </template>
                  <template v-if="currentCountryCode === 'FR'">
                    <p>{{ line1 }}</p>
                    <p>{{ line2 }}</p>
                    <p>{{ houseNumber }}</p>
                    <p>{{ zipCode }}</p>
                    <p>{{ city }}</p>
                  </template>
                  <template v-if="currentCountryCode === 'SE'">
                    <p>{{ line1 }}</p>
                    <p>{{ line2 }}</p>
                    <p>{{ houseNumber }}</p>
                    <p>{{ zipCode }}</p>
                    <p>{{ city }}</p>
                  </template>
                  <template v-if="currentCountryCode === 'RO'">
                    <p>{{ line1 }}</p>
                    <p>{{ houseNumber }}</p>
                    <p>{{ zipCode }}</p>
                    <p>{{ city }}</p>
                    <p>{{ stateCode }}</p>
                  </template>
                  <template v-if="currentCountryCode === 'CZ'">
                    <p>{{ line1 }}</p>
                    <p>{{ houseNumber }}</p>
                    <p>{{ zipCode }}</p>
                    <p>{{ city }}</p>
                  </template>
                  <template v-if="currentCountryCode === 'IT'">
                    <p>{{ line1 }}</p>
                    <p>{{ line2 }}</p>
                    <p>{{ zipCode }}</p>
                    <p>{{ city }}</p>
                    <p>{{ selectedCountryState && selectedCountryState.name }}</p>
                  </template>
                  <template v-if="currentCountryCode === 'AT'">
                    <p>{{ line1 }}</p>
                    <p>{{ line2 }}</p>
                    <p>{{ zipCode }}</p>
                    <p>{{ city }}</p>
                    <p>{{ county }}</p>
                  </template>
                  <template v-if="currentCountryCode === 'DE'">
                    <p>{{ addition }}</p>
                    <p>{{ zipCode }}</p>
                    <p>{{ city }}</p>
                  </template>
                  <template v-if="currentCountryCode === 'US' || currentCountryCode === 'CA'">
                    <p>{{ addition }}</p>
                    <p>{{ zipCode }}</p>
                    <p>{{ city }}</p>
                    <p>{{ selectedCountryState && selectedCountryState.name }}</p>
                  </template>
                  <template v-if="currentCountryCode === 'PL'">
                    <p>{{ street }}</p>
                    <p>{{ houseNumber }}</p>
                    <p>{{ extension }}</p>
                    <p>{{ zipCode }}</p>
                    <p>{{ city }}</p>
                  </template>
                  <template v-if="currentCountryCode === 'NL'">
                    <p>{{ street }}</p>
                    <p>{{ houseNumber }}</p>
                    <p>{{ extension }}</p>
                    <p>{{ zipCode }}</p>
                    <p>{{ city }}</p>
                  </template>
                </div>
              </div>

              <div class="modal-button-warpper">
                <app-button
                  type="submit"
                  @click.prevent="cancleSubmitCheckReturnAddress"
                  class="cancel_closeModal"
                >
                  {{ $t('subscription_return.cancelOrReturn.popUp.confirmAddress.button.cancel', 'Cancel') }}
                </app-button>
                <app-button
                  type="submit"
                  :disabled="!stateCode && currentCountryCode === 'GB'"
                  @click.prevent="submitCheckReturnAddress"
                  class="cancel_openModal"
                >
                  {{ $t('subscription_return.cancelOrReturn.popUp.button.processed', 'Proceed') }}
                </app-button>
              </div>
            </div>
          </div>
        </div>
      </app-modal>
      <!-- updateReturnAddress -->
      <app-modal name="step5" @after-closed="emptyCancelData" class="address_form_edit">
        <div class="v--modal-content">
          <h3 class="modal-title">
          </h3>
          <div class="modal-content">
            <div class="CancleSubscription_ReasonForm">
              <p class="title">
                {{ $t('subscription_return.cancelOrReturn.popUp.confirmAddress.button.edit.text', 'Edit address') }}
              </p>

              <div class="addressForm">
                <template v-if="currentCountryCode === 'GB' || currentCountryCode === 'ES' || currentCountryCode === 'BE'">
                  <app-text-input
                    class="return_address"
                    :label="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street and house number)')"
                    v-model.trim="line1"
                    :errors="errorsFor('line1')"
                  />
                  <app-text-input
                    class="return_address"
                    v-model.trim="line2"
                    :label="$t('common.address.textLabel&placeholder.addressLine2', 'Address line 2 (additional address line)')"
                    :errors="errorsFor('line2')"
                  />
                  <app-text-input
                    class="return_address"
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="zipCode"
                    :errors="errorsFor('zipCode')"
                  />
                  <app-text-input
                    class="return_address"
                    :label="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    v-model.trim="city"
                    :errors="errorsFor('city')"
                  />
                  <div 
                  class="SelectGroup Form_group return_address" 
                    v-if="selectedCountry && selectedCountry.states && currentCountryCode === 'GB' || selectedCountry && selectedCountry.states && currentCountryCode === 'IT' || selectedCountry && selectedCountry.states && currentCountryCode === 'ES'"
                    :class="{'error': errorsFor('selectedCountryState').length > 0}"
                  > 
                    <label class="Form_label">{{ $t('common.address.textLable.country', 'Country') }}</label>
                    <!-- <app-text-input
                      v-if="!editable"
                      class="no-border no-padding return_address"
                      :value="selectedCountry && selectedCountry.name"
                      :disabled="!editable"
                      data-name="verifyAddress-selectcountry"
                    /> -->
                    <app-select
                      :placeholder="$t('common.address.placeholder.state', 'Select your state')"
                      v-model="selectedCountryState"
                      :options="selectedCountry.states"
                      :searchable="true"
                      :allow-empty="false"
                      :show-labels="false"
                      open-direction="bottom"
                      label="name"
                      track-by="code"
                      data-name="verifyAddress-selectedCountryState"
                      :id="selectedCountry.code"
                      :disabled="submitUpdateReturnAddress.isActive"
                      @search-change="searchState"
                    />
                    <p class="tip-error" v-for="(error, index) in errorsFor('selectedCountry')" :key="index">
                      {{ $t('common.address.textLable.country', 'Country') }} {{ error }}
                    </p>
                    <!-- <app-text-input
                      v-if="editable && countries.length == 1"
                      class="no-border no-padding return_address"
                      :value="county"
                      disabled="disabled"
                      data-name="verifyAddress-selectcountry"
                    /> -->
                  </div>
                </template>
                <template v-if="currentCountryCode === 'IT'">
                  <app-text-input
                    class="return_address"
                    :label="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street and house number)')"
                    v-model.trim="line1"
                    :errors="errorsFor('line1')"
                  />
                  <app-text-input
                    class="return_address"
                    v-model.trim="line2"
                    :label="$t('common.address.textLabel&placeholder.addressLine2', 'Address line 2 (additional address line)')"
                    :errors="errorsFor('line2')"
                  />
                  <app-text-input
                    class="return_address"
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="zipCode"
                    :errors="errorsFor('zipCode')"
                  />
                  <app-text-input
                    class="return_address"
                    :label="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    v-model.trim="city"
                    :errors="errorsFor('city')"
                  />
                </template>
                <template v-if="currentCountryCode === 'RO'">
                  <app-text-input
                    class="return_address"
                    :label="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1*')"
                    v-model.trim="line1"
                    :errors="errorsFor('line1')"
                  />
                  <app-text-input
                    class="return_address"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number*')"
                    v-model.trim="houseNumber"
                    :errors="errorsFor('houseNumber')"
                  />
                  <app-text-input
                    class="return_address"
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="zipCode"
                    :errors="errorsFor('zipCode')"
                  />
                  <app-text-input
                    class="return_address"
                    :label="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    v-model.trim="city"
                    :errors="errorsFor('city')"
                  />
                  <div class="SelectGroup Form_group return_address" :class="{'error': errorsFor('selectedCountry').length > 0}">
                    <label class="Form_label">{{ $t('common.address.textLable.country', 'Country') }}</label>
                    <app-text-input
                      v-if="!editable"
                      class="no-border no-padding return_address"
                      :value="selectedCountry && selectedCountry.name"
                      :disabled="!editable"
                      data-name="verifyAddress-selectcountry"
                    />
                    <app-select
                      v-if="editable && countries.length > 1"
                      :placeholder="$t('common.address.placeholder.country', 'Select your country')"
                      v-model="county"
                      :options="countries"
                      :searchable="true"
                      :allow-empty="false"
                      :show-labels="false"
                      open-direction="bottom"
                      label="name"
                      track-by="code"
                      data-name="verifyAddress-selectcountry"
                    />
                    <p class="tip-error" v-for="(error, index) in errorsFor('selectedCountry')" :key="index">
                      {{ $t('common.address.textLable.country', 'Country') }} {{ error }}
                    </p>
                    <app-text-input
                      v-if="editable && countries.length == 1"
                      class="no-border no-padding return_address"
                      :value="county"
                      disabled="disabled"
                      data-name="verifyAddress-selectcountry"
                    />
                  </div>
                </template>
                <template v-if="currentCountryCode === 'CZ'">
                  <app-text-input
                    class="return_address"
                    :label="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street and house number)')"
                    v-model.trim="line1"
                    :errors="errorsFor('line1')"
                  />
                  <app-text-input
                    class="return_address"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number*')"
                    v-model.trim="houseNumber"
                    :errors="errorsFor('houseNumber')"
                  />
                  <app-text-input
                    class="return_address"
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="zipCode"
                    :errors="errorsFor('zipCode')"
                  />
                  <app-text-input
                    class="return_address"
                    :label="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    v-model.trim="city"
                    :errors="errorsFor('city')"
                  />
                </template>
                 <template v-if="currentCountryCode === 'AT'">
                  <app-text-input
                    class="return_address"
                    :label="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street and house number)')"
                    v-model.trim="line1"
                    :errors="errorsFor('line1')"
                  />
                  <app-text-input
                    class="return_address"
                    v-model.trim="line2"
                    :label="$t('common.address.textLabel&placeholder.addressLine2', 'Address line 2 (additional address line)')"
                    :errors="errorsFor('line2')"
                  />
                  <app-text-input
                    class="return_address"
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="zipCode"
                    :errors="errorsFor('zipCode')"
                  />
                  <app-text-input
                    class="return_address"
                    :label="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    v-model.trim="city"
                    :errors="errorsFor('city')"
                  />
                  <div class="SelectGroup Form_group return_address" :class="{'error': errorsFor('selectedCountry').length > 0}">
                    <label class="Form_label">{{ $t('common.address.textLable.country', 'Country') }}</label>
                    <app-text-input
                      v-if="!editable"
                      class="no-border no-padding return_address"
                      :value="selectedCountry && selectedCountry.name"
                      :disabled="!editable"
                      data-name="verifyAddress-selectcountry"
                    />
                    <app-select
                      v-if="editable && countries.length > 1"
                      :placeholder="$t('common.address.placeholder.country', 'Select your country')"
                      v-model="county"
                      :options="countries"
                      :searchable="true"
                      :allow-empty="false"
                      :show-labels="false"
                      open-direction="bottom"
                      label="name"
                      track-by="code"
                      data-name="verifyAddress-selectcountry"
                    />
                    <p class="tip-error" v-for="(error, index) in errorsFor('selectedCountry')" :key="index">
                      {{ $t('common.address.textLable.country', 'Country') }} {{ error }}
                    </p>
                    <app-text-input
                      v-if="editable && countries.length == 1"
                      class="no-border no-padding return_address"
                      :value="county"
                      disabled="disabled"
                      data-name="verifyAddress-selectcountry"
                    />
                  </div>
                </template>
                <template v-if="currentCountryCode === 'FR' || currentCountryCode === 'SE'">
                  <app-text-input
                    class="return_address"
                    :label="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street and house number)')"
                    v-model.trim="line1"
                    :errors="errorsFor('line1')"
                  />
                  <app-text-input
                    class="return_address"
                    v-model.trim="line2"
                    :label="$t('common.address.textLabel&placeholder.addressLine2', 'Address line 2*')"
                    :errors="errorsFor('line2')"
                  />
                  <app-text-input
                    class="return_address"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number*')"
                    v-model.trim="houseNumber"
                    :errors="errorsFor('houseNumber')"
                  />
                  <app-text-input
                    class="return_address"
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="zipCode"
                    :errors="errorsFor('zipCode')"
                  />
                  <app-text-input
                    class="return_address"
                    :label="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    v-model.trim="city"
                    :errors="errorsFor('city')"
                  />
                </template>
                <template v-if="currentCountryCode === 'DE'">
                  <app-text-input
                    class="return_address"
                    :label="$t('common.address.textLabel&placeholder.address', 'Address')"
                    v-model.trim="addition"
                    :errors="errorsFor('addition')"
                    data-name="verifyAddress-addition"
                  />
                  <app-text-input
                    class="return_address"
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="zipCode"
                    :errors="errorsFor('zipCode')"
                    data-name="verifyAddress-zipCode"
                  />
                  <app-text-input
                    class="return_address"
                    :label="$t('common.address.textLabel&placeholder.city', 'City')"
                    v-model.trim="city"
                    :errors="errorsFor('city')"
                    data-name="verifyAddress-city"
                  />
                </template>
                <template v-if="currentCountryCode === 'US' || currentCountryCode === 'CA'">
                  <app-text-input
                    class="return_address"
                    :label="$t('common.address.textLabel&placeholder.address', 'Address')"
                    v-model.trim="addition"
                    :errors="errorsFor('addition')"
                    data-name="verifyAddress-addition"
                  />
                  <app-text-input
                    class="return_address"
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="zipCode"
                    :errors="errorsFor('zipCode')"
                    data-name="verifyAddress-zipCode"
                  />
                  <app-text-input
                    class="return_address"
                    :label="$t('common.address.textLabel&placeholder.city', 'City')"
                    v-model.trim="city"
                    :errors="errorsFor('city')"
                    data-name="verifyAddress-city"
                  />
                  <div
                    class="SelectGroup Form_group return_address"
                    v-if="selectedCountry && selectedCountry.states && currentCountryCode === 'US'"
                    :class="{'error': errorsFor('selectedCountryState').length > 0}"
                  >
                    <label class="Form_label">{{ $t('common.address.textLable.state', 'State') }}</label>
                    <app-select
                      :placeholder="$t('common.address.placeholder.state', 'Select your state')"
                      v-model="selectedCountryState"
                      :options="selectedCountry.states"
                      :searchable="true"
                      :allow-empty="false"
                      :show-labels="false"
                      open-direction="bottom"
                      label="name"
                      track-by="code"
                      data-name="verifyAddress-selectedCountryState"
                      :id="selectedCountry.code"
                      :disabled="submitUpdateReturnAddress.isActive"
                      @search-change="searchState"
                    />
                    <p class="tip-error" v-for="(error, index) in errorsFor('selectedCountryState')" :key="index">
                      {{ $t('common.address.textLable.state', 'State') }} {{ error }}
                    </p>
                  </div>
                  <div
                    class="SelectGroup Form_group return_address"
                    v-if="selectedCountry && selectedCountry.states && currentCountryCode === 'CA'"
                    :class="{'error': errorsFor('selectedCountryState').length > 0}"
                  >
                    <label class="Form_label">{{ $t('common.address.textLable.province', 'Province') }}</label>
                    <app-select
                      :placeholder="$t('common.address.placeholder.province', 'Select your province')"
                      v-model="selectedCountryState"
                      :options="selectedCountry.states"
                      :searchable="true"
                      :allow-empty="false"
                      :show-labels="false"
                      open-direction="bottom"
                      label="name"
                      track-by="code"
                      data-name="verifyAddress-selectedCountryState"
                      :id="selectedCountry.code"
                      :disabled="submitUpdateReturnAddress.isActive"
                      @search-change="searchState"
                    />
                    <p class="tip-error" v-for="(error, index) in errorsFor('selectedCountryState')" :key="index">
                      {{ $t('common.address.textLable.province', 'Province') }} {{ error }}
                    </p>
                  </div>
                </template>
                <template v-if="currentCountryCode === 'PL'">
                  <app-text-input
                    class="return_address"
                    :label="$t('common.address.textLabel&placeholder.street', 'Street')"
                    v-model.trim="street"
                    :errors="errorsFor('street')"
                    data-name="verifyAddress-street"
                  />
                  <app-text-input
                    class="return_address"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    v-model.trim="houseNumber"
                    :errors="errorsFor('houseNumber')"
                  />

                  <app-text-input
                    class="return_address"
                    :label="$t('common.address.textLabel&placeholder.extension', 'extension')"
                    v-model.trim="extension"
                    :errors="errorsFor('extension')"
                    data-name="editShippingAddress-extension"
                  />
                  <app-text-input
                    class="return_address"
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="zipCode"
                    :errors="errorsFor('zipCode')"
                    data-name="verifyAddress-zipCode"
                  />
                  <app-text-input
                    class="return_address"
                    :label="$t('common.address.textLabel&placeholder.city', 'City')"
                    v-model.trim="city"
                    :errors="errorsFor('city')"
                    data-name="verifyAddress-city"
                  />
                </template>
                <template v-if="currentCountryCode === 'NL'">
                  <app-text-input
                    class="return_address"
                    :label="$t('common.address.textLabel&placeholder.street', 'Street')"
                    v-model.trim="street"
                    :errors="errorsFor('street')"
                    data-name="verifyAddress-street"
                  />
                  <app-text-input
                    class="return_address"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    v-model.trim="houseNumber"
                    :errors="errorsFor('houseNumber')"
                  />

                  <app-text-input
                    class="return_address"
                    :label="$t('common.address.textLabel&placeholder.extension', 'extension')"
                    v-model.trim="extension"
                    :errors="errorsFor('extension')"
                    data-name="editShippingAddress-extension"
                  />
                  <app-text-input
                    class="return_address"
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="zipCode"
                    :errors="errorsFor('zipCode')"
                    data-name="verifyAddress-zipCode"
                  />
                  <app-text-input
                    class="return_address"
                    :label="$t('common.address.textLabel&placeholder.city', 'City')"
                    v-model.trim="city"
                    :errors="errorsFor('city')"
                    data-name="verifyAddress-city"
                  />
                </template>
              </div>

              <div class="modal-button-warpper updateAddressButton">
                <app-button
                  type="submit"
                  :is-loading="submitUpdateReturnAddress.isActive"
                  @click.prevent="submitUpdateReturnAddress.run()"
                  class="cancel_openModal"
                >
                  {{ $t('subscription_return.cancelOrReturn.popUp.confirmAddress.button.save', 'Save') }}
                </app-button>
                <app-button
                  type="submit"
                  @click.prevent="cancelUpdateReturnAddress.run()"
                  :is-loading="cancelUpdateReturnAddress.isActive"
                  class="cancel_closeModal"
                >
                  {{ $t('subscription_return.cancelOrReturn.popUp.confirmAddress.button.cancel', 'Cancel') }}
                </app-button>
              </div>
            </div>
          </div>
        </div>
      </app-modal>
      <!--  doReturnSubscription-->
      <app-modal name="doReturnSubscription" @after-closed="emptyCancelData">
        <div class="v--modal-content">
          <h3 class="modal-title">
          </h3>
          <div class="modal-content">
            <div class="CancleSubscription_ReasonForm">
              <p class="title">
                {{ $t('subscription_details.cancelOrReturn.popUp.cancel.return.title', 'What happens next?') }}
              </p>

              <p class="tips">
                {{ $t('subscription_details.cancelOrReturn.popUp.cancel.return.tips', 'As soon as we have received your product, your cancellation will be confirmed and payment will be stopped.') }}
              </p>

              <p class="tips">
                {{ $t('subscription_details.cancelOrReturn.popUp.cancel.return.info', 'We have sent you an email at') }}
                <b>{{ consumerEmail }}</b>,
                {{ $t('subscription_details.cancelOrReturn.popUp.cancel.return.subInfo', 'with a return label and instructions on how to send the product back to us for free.') }}
              </p>

              <div class="modal-button-warpper">
                <app-button
                  type="submit"
                  @click="submitDoReturnSubscription.run()"
                  :is-loading="submitDoReturnSubscription.isActive"
                  class="cancel_openModal"
                >
                  {{ $t('subscription_details.cancelOrReturn.popUp.cancel.button.ok', 'OK') }}
                </app-button>
              </div>
            </div>
          </div>
        </div>
      </app-modal>
      <app-modal name="replenishmentCancellationConfirm" width="597px" min-height="210px" @after-closed="emptyCancelData" class="replenishmentCancellationConfirm">
        <div class="v--modal-content">
          <h3 class="modal-title"></h3>
          <div class="modal-content">
            <h4
              v-html="$t('subscription_details.accordion.popUp.cancellation.title', {
                finalPaymentDate: replenishmentCancellationConfirmInfos.finalPaymentDate
              })"
            ></h4>
            <p
              class="tips_replenshipment_cancel"
              v-html="$t('subscription_details.accordion.popUp.cancellation.content', {
                paidAmount: replenishmentCancellationConfirmInfos.paidAmount,
                remainingAmount: replenishmentCancellationConfirmInfos.remainingAmount,
                price: replenishmentCancellationConfirmInfos.price,
                finalPaymentDate: replenishmentCancellationConfirmInfos.finalPaymentDate
            })"></p>
            <div class="modal-button-warpper">
              <app-button
                type="submit"
                @click="cancelReplenishmentCancellation"
                class="cancel_closeModal"
              >
                {{ $t('subscription_return.cancelOrReturn.popUp.replenishmentCancellation.button.cancel', 'Cancel') }}
              </app-button>
              <app-button
                type="submit"
                @click.prevent="submitReplenishmentCancellation.run()"
                :is-loading="submitReplenishmentCancellation.isActive"
                class="cancel_openModal"
              >
                {{ $t('subscription_return.cancelOrReturn.popUp.replenishmentCancellation.button.understand', 'l understand') }}
              </app-button>
            </div>
          </div>
        </div>
      </app-modal>

      <app-modal name="newFlowForCancelReplenishment" ref="newFlowForCancelReplenishment" @after-closed="emptyCancelData" width="500px">
        <div class="v--modal-content">
          <h3 class="modal-title">
          </h3>
          <div class="modal-content">
            <div class="newFlowForCancelReplenishment_popUp">
              <h4>
                {{ $t('subscription_details.cancellation.popUp.tips', "We are sorry to hear that you want to cancel your subscription.") }}
              </h4>

              <h4
                v-if="(!disabledAllAccordion && !subscriptionDetails.ableToResumeReplenishment &&
                  subscriptionDetails.tryBuyHasShipped &&
                returnOptionType === 'TryBuy')">
                {{ $t('subscription_details.cancellation.popUp.modify.subTips', "Did you know you can also modify your subscription to a different plan?") }}
              </h4>

              <h4
                v-if="(!disabledAllAccordion && !subscriptionDetails.ableToResumeReplenishment &&
                  subscriptionDetails.tryBuyHasShipped && subscriptionDetails.ableToPauseReplenishment &&
                returnOptionType !== 'TryBuy')">
                {{ $t('subscription_details.cancellation.popUp.pauseOrModify.subTips', "Did you know you can also pause your subscription? Or modify your subscription to a different plan?") }}
              </h4>

              <div class="modal-button-warpper">
                <app-button
                  class="cancel_closeModal"
                  v-if="subscriptionDetails.ableToPauseReplenishment && returnOptionType !== 'TryBuy'"
                  @click.prevent="pauseReplenishment"
                >
                  {{ $t('subscription_details.cancellation.popUp.button.pause', "Pause") }}
                </app-button>
                <app-button
                  class="cancel_closeModal"
                  v-if="displayModifyButton || (
                  subscriptionDetails.tryBuyHasShipped && !disabledAllAccordion && !subscriptionDetails.ableToResumeReplenishment)"
                  @click.prevent="modifySubscription"
                >
                  {{ $t('subscription_details.cancellation.popUp.button.modify', "Modify") }}
                </app-button>

                <app-button
                  class="cancel_openModal"
                  @click.prevent="doCancelFlow"
                >
                  {{ $t('subscription_details.cancellation.popUp.button.cancel', "Cancel") }}
                </app-button>
              </div>
            </div>
          </div>
        </div>
      </app-modal>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import { cloneDeep } from 'lodash'
  import { mapValueProperties, getErrors, extractErrorMessage } from '@/utilities/common'
  import { includeNumberRegex, addressRegex } from '@/utilities/common/validators'
  import { required, maxLength, minLength } from 'vuelidate/lib/validators'
  import Vue from 'vue'
  import { detectedCulture } from 'utilities/common/culture'
  import ReturnCommonMixin from 'mixins/return-general'
  import ReturningWithdraw from './ReturningWithdraw'
  import SubscriptionDetailsAccordion from 'components/SubscriptionDetailsAccordion'
  import {
    region
 } from 'utilities/cluture/region'

  export default {
    name: 'not-only-replenshipment',
    mixins: [ReturnCommonMixin],
    data () {
      return {
        SubscriptionDetailsAccordion,
        cancelOption: null,
        step1Show: false,
        cancelMoreInfo: '',
        hideChecked: false,
        address: {},
        currentIndex: -1,
        editable: false,
        preEditAddress: {},
        updateAddressSuccess: false,
        currentCountryCode: detectedCulture.countryCode,
        region: region[detectedCulture.countryCode],
        cancelOrReturnOption: [
          {
            text: this.$t('subscription_details.accordion.cancel.bundles.selectStatus.keepProduct', 'Yes, l want to keep it.'),
            id: 'cancel-type-keep'
          },
           {
             text: this.$t('subscription_details.accordion.cancel.bundles.selectStatus.returnProduct', 'No, l will return it.'),
             id: 'cancel-type-return'
          }
        ],
        replenishmentCancellationConfirmInfos: {}
      }
    },

    props: {
      device: {
        type: Object,
        required: true
      },
      replenshipment: {
        type: Object,
        required: true
      }
    },

    components: {
      ReturningWithdraw
    },

    validations () {
      let AddressObject
      if (this.currentCountryCode === 'GB' || this.currentCountryCode === 'ES' || this.currentCountryCode === 'BE' || this.currentCountryCode === 'IT' || this.currentCountryCode === 'AT' || this.currentCountryCode === 'FR' || this.currentCountryCode === 'SE' || this.currentCountryCode === 'RO' || this.currentCountryCode === 'CZ') {
        AddressObject = {
          line1: {
            required,
            Addressline1 (value) {
              if (!value) return true
              return /^[\da-zA-Z\a-zA-ZùÙüÜáčďéěíňóřšťúůýžäàáčďéěíňóřšťúůýžáëèéïìíöòóüùúÄÀÅÁÁČĎÉĚÍŇÓŘŠŤÚŮÝŽËÈÉÏÌÍÖÒÓÜÚñÑ\s]{1,32}$/.test(value)
            },
            maxLength: maxLength(35),
            minLength: minLength(4)
          },
          line2: {
            Addressline2 (value) {
              if (!value) return true
              return /^[\da-zA-Z\a-zA-ZùÙüÜáčďéěíňóřšťúůýžäàáčďéěíňóřšťúůýžáëèéïìíöòóüùúÄÅÀÁČĎÉĚÍŇÓŘŠŤÚŮÝŽÁËÈÉÏÌÍÖÒÓÜÚñÑ\s]{0,15}$/.test(value)
            }
          },
          city: {
            required,
            town (value) {
              if (!value) return true
              return /^[\da-zA-Z\a-zA-ZùÙüÜáčďéěíňóřšťúůýžäàááčďéěíňóřšťúůýžëèéïìíöòóüùúÄÀÅÁČĎÉĚÍŇÓŘŠŤÚŮÝŽÁËÈÉÏÌÍÖÒÓÜÚñÑ\s]{1,20}$/.test(value)
            }
          },
          county: {
            required
          },
          zipCode: {
            required,
            zipCode (value) {
              if (!value) return true
              return this.selectedCountry.zipCodeRegex.test(value)
            }
          }
        }
      } else {
        AddressObject = {
          street: {
            required (value) {
              if (this.selectedCountry.street_housenumber_extension_field === 3) {
                return !!value
              } else {
                return true
              }
            },
            address (value) {
              if (this.selectedCountry.street_housenumber_extension_field === 3) {
                return !addressRegex.test(value)
              } else {
                return true
              }
            },
            maxLength: maxLength(22),
            minLength: minLength(2)
          },
          addition: {
            required (value) {
              if (this.selectedCountry.street_housenumber_extension_field === 1) {
                return !!value
              } else {
                return true
              }
            },
            includeNumber (value) {
              if (this.selectedCountry.street_housenumber_extension_field === 1) {
                return includeNumberRegex.test(value)
              } else {
                return true
              }
            },
            address (value) {
              if (this.selectedCountry.street_housenumber_extension_field === 1) {
                return !addressRegex.test(value)
              } else {
                return true
              }
            },
            maxLength: maxLength(35),
            minLength: minLength(4)
          },
          extension: {
            maxLength: maxLength(9)
          },
          selectedCountry: {
            required
          },
          selectedCountryState: {
            required (value) {
              if (this.selectedCountry.states) {
                return !!value
              } else {
                return true
              }
            }
          },
          zipCode: {
            required,
            zipCode (value) {
              if (!value) return true
              return this.selectedCountry.zipCodeRegex.test(value)
            }
          },
          city: {
            required,
            maxLength: maxLength(20),
            minLength: minLength(2)
          },
          houseNumber: {
            required (value) {
              if (this.selectedCountry.street_housenumber_extension_field === 3) {
                return !!value
              } else {
                return true
              }
            },
            houseNumber (value) {
              if (this.selectedCountry.street_housenumber_extension_field === 3) {
                return this.selectedCountry.houseNumberRegexs.test(value)
              } else {
                return true
              }
            }
          }
        }
      }
      return { ...AddressObject }
    },

    computed: {
      ...mapState('subscription', ['subscriptionDetails']),

      ...mapState('culture', ['countries']),

      ...mapValueProperties('address', [
        'countryCode',
        'stateCode',
        'city',
        'zipCode',
        'addition',
        'street',
        'houseNumber',
        'extension',
        'line1',
        'line2',
        'county'
      ], { modifyOriginal: true }),

      selectedCountry: {
        get () {
          return this.countries.length === 1 ? this.countries[0] : this.countryCode &&
            this.countries.find(country => country.code === this.countryCode)
        },

        set (selectedCountry) {
          this.countryCode = selectedCountry.code
          this.stateCode = null
        }
      },

      selectedCountryState: {
        get () {
          if (this.currentCountryCode === 'GB') {
            return this.selectedCountry.states &&
              this.county &&
              this.selectedCountry.states.find(state => state.name === this.county)
          } else {
            return this.selectedCountry.states &&
              this.stateCode &&
              this.selectedCountry.states.find(state => state.code === this.stateCode)
          }
        },

        set (selectedCountryState) {
          if (this.currentCountryCode === 'GB') {
            this.county = selectedCountryState.name
          } else {
            this.stateCode = selectedCountryState.code
          }
        }
      },

      disabledCancelButton () {
        return (this.returnOptionType !== 'Replenishment' ||
          (this.returnOptionType === 'Replenishment' &&
          this.replenshipmentReturnInfos && this.replenshipmentReturnInfos.returnable && !this.subscriptionDetails.ableToCancelReplenishment))
      }
    },

    methods: {
      errorsFor (field) {
        if (!this.showValidations) {
          return []
        }

        if (this.$v[field] == null) {
          return []
        }

        return getErrors(this.$v[field])
      },

      searchState (query, conuntryCode) {
        this.$store.commit('culture/filterStates', { query, conuntryCode })
      },

      existNewFlowForCancelReplenishment () {
        if (this.$refs.newFlowForCancelReplenishment) {
          this.$bus.$emit('close-modal', 'newFlowForCancelReplenishment')
        }
      },

      openModalStep2 () {
        this.$bus.$emit('open-modal', 'newFlowForCancelReplenishment1')
      },

      doCancelFlow () {
        this.existNewFlowForCancelReplenishment()
        if (this.returnOptionType === 'Replenishment' && (!this.replenshipmentReturnInfos.returnable && this.subscriptionDetails.ableToCancelReplenishment)) {
          // replenshipment can only do cancel
          this.$bus.$emit('open-modal', 'submitReturnSubscriptionReason')
        } else if (!this.replenshipmentReturnInfos.returnable && !this.deviceReturnInfos.returnable) {
          this.$bus.$emit('open-modal', 'submitReturnSubscriptionReason')
        } else {
          // replenshipment can cancel and return
          this.$bus.$emit('open-modal', 'selectReturnOrCancel')
        }
      },

      returnProcessStart () {
        if (this.needNewCancellationFlow) {
          this.$bus.$emit('open-modal', 'newFlowForCancelReplenishment')
        } else {
          this.doCancelFlow()
          this.existNewFlowForCancelReplenishment()
        }
      },

      cancelReturn () {
        this.$bus.$emit('close-modal', 'selectReturnOrCancel')
        this.emptyCancelData()
      },

      selectReturnOptions () {
        this.$bus.$emit('open-modal', 'submitReturnSubscriptionReason')
        this.$bus.$emit('close-modal', 'selectReturnOrCancel')
      },

      emptyCancelData () {
        this.cancelReason = cloneDeep(this.initialCancelReason)
        this.cancelMoreInfo = ''
        this.currentIndex = -1
        this.step1Show = false
        this.cancelOption = null
        this.canDoReturnBundles = this.returnBundleOptions()
        this.updateAddressSuccess = false
      },

      CancelreturnSubscriptionReasonPopup () {
        this.$bus.$emit('close-modal', 'submitReturnSubscriptionReason')
        this.emptyCancelData()
        this.hideChecked = true
      },

      editAddress () {
        if (!this.editable) {
          this.editable = true
          this.preEditAddress = cloneDeep(this.address)
          this.$bus.$emit('open-modal', 'step5')
          this.$bus.$emit('close-modal', 'checkReturnAddress')
        } else {
          this.editable = false
          this.address = this.preEditAddress
        }
      },

      submitCheckReturnAddress () {
        this.$bus.$emit('open-modal', 'doReturnSubscription')
        this.$bus.$emit('close-modal', 'checkReturnAddress')
      },

      cancelBundleStep3 () {
        this.$bus.$emit('open-modal', 'checkReturnAddress')
        this.$bus.$emit('close-modal', 'doReturnSubscription')
      },

      cancleSubmitCheckReturnAddress () {
        this.$bus.$emit('close-modal', 'checkReturnAddress')
        this.emptyCancelData()
      },

      selectCancelOrReturnOption (index, item) {
        if (index !== this.currentIndex) {
          if (this.returnOptionType !== 'Replenishment' && item.id !== 'cancel-type-keep') {
            this.currentIndex = index
            this.step1Show = true
          } else if (this.returnOptionType === 'Replenishment' && (item.id !== 'cancel-type-keep' && this.replenshipmentReturnInfos.returnable && !this.subscriptionDetails.ableToCancelReplenishment)) {
            this.currentIndex = index
            this.step1Show = true
          } else if (this.returnOptionType === 'Replenishment' && this.replenshipmentReturnInfos.returnable && this.subscriptionDetails.ableToCancelReplenishment) {
            this.currentIndex = index
            this.step1Show = true
          }
        } else {
          this.currentIndex = -1
          this.step1Show = false
        }
        this.cancelOption = this.$refs.returnSubscription[index].id
      },

      cancelSubscription () {
        this.$bus.$emit('open-modal', 'step2')
        this.$bus.$emit('close-modal', 'newFlowForCancelReplenishment1')
      },

      closeModalStep2 () {
        this.$bus.$emit('close-modal', 'step2')
        this.cancelReason = cloneDeep(this.initialCancelReason)
        this.cancelMoreInfo = ''
      },

      cancelReplenishmentCancellation () {
        this.$bus.$emit('close-modal', 'replenishmentCancellationConfirm')
        this.emptyCancelData()
      }
    },

    tasks (t) {
      return {
        submitUpdateReturnAddress: t(async function () { // update re-address
          this.$v.$touch()
          if (this.$v.$invalid) {
            this.showValidations = true
          } else {
            this.editable = false
          }
          if (this.street && this.houseNumber && this.extension && (this.street.concat(this.houseNumber, this.extension).length > 4) && (this.street.concat(this.houseNumber, this.extension).length < 35)) {
            await Vue.api.subscription.updateReturnAddress2(this.returnOptionType, this.subscriptionDetails.number, this.address)
            await this.$store.dispatch('subscription/fetchSubscriptionDetails', this.subscriptionDetails.number)
            this.updateAddressSuccess = true
            this.$bus.$emit('open-modal', 'checkReturnAddress')
            this.$bus.$emit('close-modal', 'step5')
          } else {
            await Vue.api.subscription.updateReturnAddress2(this.returnOptionType, this.subscriptionDetails.number, this.address)
            await this.$store.dispatch('subscription/fetchSubscriptionDetails', this.subscriptionDetails.number)
            this.updateAddressSuccess = true
            this.$bus.$emit('open-modal', 'checkReturnAddress')
            this.$bus.$emit('close-modal', 'step5')
          }
        }).onError(function (task) {
          this.$notify({
            type: 'error',
            title: extractErrorMessage(task.error)
          })
        }),

        submitReturnSubscriptionReason: t(async function () { // callback draft return api
          // cancel replenshipment
          if (this.cancelOption === 'cancel-type-keep' || (!this.replenshipmentReturnInfos.returnable && this.subscriptionDetails.ableToCancelReplenishment && !this.cancelOption)) {
            await Vue.api.subscription.replenishmentCancellationPreview(this.subscriptionDetails.number).then((data) => {
              this.replenishmentCancellationConfirmInfos = data.data.result
              this.replenishmentCancellationConfirmInfos.remainingAmount = this.replenishmentCancellationConfirmInfos.totalAmount - this.replenishmentCancellationConfirmInfos.paidAmount
              this.replenishmentCancellationConfirmInfos.finalPaymentDate = this.$options.filters.formatLocalDate(this.replenishmentCancellationConfirmInfos.finalPaymentDate)
              if (this.replenishmentCancellationConfirmInfos.remainingAmount > 0) {
                this.$bus.$emit('open-modal', 'replenishmentCancellationConfirm')
              } else {
                this.submitReplenishmentCancellation.run()
              }
              this.$bus.$emit('close-modal', 'submitReturnSubscriptionReason')
            })
          } else {
            // return, replenshipment and device both do return
            if (this.subscriptionDetails.contentProductName === 'Lumea' && this.currentCountryCode === 'GB') {
            await Vue.api.subscription.returnTryBuyBundledReturn(this.subscriptionDetails.number, this.returnOptionType, this.cancelReasonSelected, this.cancelMoreInfo)
            await this.$store.dispatch('subscription/fetchSubscriptionDetails', this.subscriptionDetails.number)
            this.$bus.$emit('open-modal', 'checkReturnAddress')
            this.$bus.$emit('close-modal', 'submitReturnSubscriptionReason')
            } else {
            await Vue.api.subscription.returnTryBuySubscription(this.subscriptionDetails.number, this.returnOptionType, this.cancelReasonSelected, this.cancelMoreInfo)
            await this.$store.dispatch('subscription/fetchSubscriptionDetails', this.subscriptionDetails.number)
            this.$bus.$emit('open-modal', 'checkReturnAddress')
            this.$bus.$emit('close-modal', 'submitReturnSubscriptionReason')
          }
          }
        }).onError(function (task) {
          this.$notify({
            type: 'error',
            title: extractErrorMessage(task.error)
          })
        }),

        submitReplenishmentCancellation: t(async function () {
          await Vue.api.subscription.cancelReplenishment(this.subscriptionDetails.number)
          await this.$store.dispatch('subscription/fetchSubscriptionDetails', this.subscriptionDetails.number)
          this.$bus.$emit('close-modal', 'replenishmentCancellationConfirm')
          this.emptyCancelData()
        }).onError(function (task) {
          this.$notify({
            type: 'error',
            title: extractErrorMessage(task.error)
          })
        }),

        submitDoReturnSubscription: t(async function () { // get carrier, update address, return subscription
          if (this.street && this.houseNumber && this.extension && (this.street.concat(this.houseNumber, this.extension).length > 4) && (this.street.concat(this.houseNumber, this.extension).length < 35)) {
            await Vue.api.subscription.updateReturnAddress2(this.returnOptionType, this.subscriptionDetails.number, this.address)
            const { replenishmentCarriers, tryBuyCarriers } = await Vue.api.subscription.getReturnCarries(this.subscriptionDetails.number, this.returnOptionType)
            const tryBuyCarrier = tryBuyCarriers && tryBuyCarriers[0]
            const replenishmentCarrier = replenishmentCarriers && replenishmentCarriers[0]
            await Vue.api.subscription.submitReturnCarrier(this.subscriptionDetails.number, tryBuyCarrier, replenishmentCarrier)
            await this.$store.dispatch('subscription/fetchSubscriptionDetails', this.subscriptionDetails.number)
            this.$bus.$emit('close-modal', 'checkReturnAddress')
            this.emptyCancelData()
          } else {
            await Vue.api.subscription.updateReturnAddress2(this.returnOptionType, this.subscriptionDetails.number, this.address)
            const { replenishmentCarriers, tryBuyCarriers } = await Vue.api.subscription.getReturnCarries(this.subscriptionDetails.number, this.returnOptionType)
            const tryBuyCarrier = tryBuyCarriers && tryBuyCarriers[0]
            const replenishmentCarrier = replenishmentCarriers && replenishmentCarriers[0]
            await Vue.api.subscription.submitReturnCarrier(this.subscriptionDetails.number, tryBuyCarrier, replenishmentCarrier)
            await this.$store.dispatch('subscription/fetchSubscriptionDetails', this.subscriptionDetails.number)
            this.$bus.$emit('close-modal', 'checkReturnAddress')
            this.emptyCancelData()
          }
          this.$bus.$emit('close-modal', 'doReturnSubscription')
          window.location.reload()
        }).onError(function (task) {
          this.$notify({
            type: 'error',
            title: extractErrorMessage(task.error)
          })
        }),

        cancellationSubscriptionTask: t(async function () {
            await Vue.api.subscription.bcbscancellation(this.subscriptionDetails.number,this.cancelReasonSelected, this.cancelMoreInfo)
          this.$router.replace({
            name: 'my-account'
          })
        }).onError(function (task) {
          this.$notify({
            type: 'error',
            title: extractErrorMessage(task.error)
          })
        }),

        cancelUpdateReturnAddress: t(async function () { // cancel update address
          this.$bus.$emit('open-modal', 'checkReturnAddress')
          this.$bus.$emit('close-modal', 'step5')
        }).onError(function (task) {
          this.$notify({
            type: 'error',
            title: extractErrorMessage(task.error)
          })
        })
      }
    },

    created () {
      this.cancelReason = cloneDeep(this.initialCancelReason)
      this.canDoReturnBundles = this.returnBundleOptions()
      Vue.api.subscription.getReturnAddress2().then(data => {
        this.address = data
      }).catch(error => {
        this.$notify({
          type: 'error',
          title: extractErrorMessage(error)
        })
      })
    }
  }
</script>

<style lang="scss">
.NotOnlyReplenshipment {
  .text {
    margin-bottom: .24rem;
    font-weight: bold;
  }

  .trybuyReturnAndReplCancel_tips {
    color: $blue;
    padding: .1rem 0 0;
    font-size: .14rem;
    line-height: .22rem;

    @include media (tablet) {
      padding: .1rem 0 0;
      font-size: .16rem;
      line-height: .24rem;
    }
  }

  .trybuy_cancel_options {
    display: flex;

    .cancelButNotReturn {
      .AppCheckbox {
        &_label {
          display: flex;
          align-items: center;
          justify-content: center;
          height: .24rem;
          width: .24rem;
          background: transparent;
          border: .01rem solid #c4c4c4;
          border-radius: 50%;

          .Form_label {
            padding-left: 0;
          }
        }

        .Form_label {
          padding-left: 0 !important;
        }
      }

      .Form_group {
        margin-bottom: .16rem;
      }

      .Form_group:nth-last-child(1) {
        margin-bottom: 0;
      }

      .Form_label {
        font-size: .16rem;
        line-height: .22rem;
        margin: .01rem 0;
        color: #454545;
        letter-spacing: -.0001rem;
      }
    }

    .cancel_options_title {
      line-height: .24rem;
      color: #e8e8e8;
    }

    .cancel_optionSelect_title {
      color: $font-black;
    }
  }

  .CancleSubscription_ReasonForm .selectRadio {
    ul {
      li {
        display: flex;
        margin-bottom: .17rem;
        cursor: pointer;

        .payment-method_radio {
          display: flex;
          align-items: center;
          justify-content: center;
          height: .24rem;
          width: .24rem;
          background: transparent;
          border: .01rem solid #c4c4c4;
          border-radius: 50%;
          margin-right: .14rem;
        }

        .payment-method_radioExtend {
          display: flex;
          align-items: center;
          justify-content: center;
          height: .24rem;
          width: .24rem;
          background: transparent;
          border: .01rem solid #c4c4c4;
          border-radius: 50%;
          margin-right: .14rem;
          border-color: #1f78a7;

          &::after {
            content: "";
            width: .08rem;
            height: .08rem;
            display: block;
            background: #1f78a7;
            border-radius: 50%;
          }
        }
      }

      li.disabled {
        cursor: default;
        color: #d6d6d6;
      }

      li:nth-last-child(1) {
        margin-bottom: .32rem;
      }
    }
  }

  .selectReturnOrCancel {
    .v--modal-content {
      .subTips {
        line-height: .24rem;
        letter-spacing: .002rem;
        color: #212121;
        font-size: .16rem;
        margin: .06rem 0 .32rem;
      }
    }
  }

  .cancelProcess {
    width: auto;
    margin-top: .24rem;

    @include media(tablet) {
      min-width: 30%;
    }
  }

  .address {
    &_edit {
      position: absolute;
      left: 50%;
    }

    &Form {
      .return_address.error {
        border: 0;
        padding: 0;
      }

      .return_address {
        border: .01rem solid #e8e8e8;
        padding: .04rem .1rem;

        .Form_label {
          color: #8c8c8c;
          line-height: .18rem;
        }

        .Form_control {
          font-size: .16rem;
          border: 0;
          padding: 0;
          line-height: .22rem;
        }

        .multiselect__tags {
          border: none;
          padding-left: 0;
        }
      }

      .error .Form_group_content {
        border: solid $pink .01rem;
        padding: .04rem .1rem;
      }
    }

    &_content {
      p {
        margin-bottom: 0 !important;
        line-height: .22rem;
        letter-spacing: .0017rem;
        max-width: 50%;
      }
    }
  }

  .address_form_edit {
    .cancel_openModal {
      margin-right: .1rem;
    }
  }

  .newFlowForCancelReplenishment_popUp {
    .modal-button-warpper {
      justify-content: flex-start !important;

      .AppButton {
        width: 30% !important;
        background-color: $blue !important;
        color: #fff !important;
      }
    }
  }
}
</style>
